// Wrapper around CampaignForm for the new-campaign flow.
//
// Step composition lives entirely on the Steps tab now. The previous
// inline "Step 1 template" inputs were removed (PR-block-9, May 2026):
// they encouraged users to ship a half-baked subject + body without
// previewing in the rich editor, and they made the create surface
// unnecessarily long. New flow: create the draft with no steps,
// land the user on the campaign detail's Steps tab with a fresh
// Step 1 editor open and ready to fill in.

import {
  useAffinityListConfigs,
  useCreateCampaign,
  useOutreachSenders,
} from '../../hooks/useOutreach';
import type { CampaignIn } from '../../types/outreach';
import { CampaignForm, type CampaignFormSubmit } from './CampaignForm';


export function CampaignCreate({ onClose }: { onClose: (newId?: number) => void }) {
  const sendersQ = useOutreachSenders();
  const listsQ = useAffinityListConfigs();
  const createMut = useCreateCampaign();

  async function handleSubmit(body: CampaignFormSubmit) {
    if (body._mode !== 'create') return; // type narrowing safety
    // Strip the discriminator before posting; backend rejects extra
    // keys per Pydantic config. Steps come later via the Step editor.
    const { _mode, ...rest } = body;
    const payload: CampaignIn = { ...rest, steps: [] };
    const created = await createMut.mutateAsync(payload);
    onClose(created.id);
  }

  return (
    <CampaignForm
      mode="create"
      listConfigs={listsQ.data || []}
      senders={sendersQ.data || []}
      onSubmit={handleSubmit}
      onCancel={() => onClose()}
      submitLabel={createMut.isPending ? 'Creating…' : 'Create as draft'}
      isSubmitting={createMut.isPending}
      title="New campaign"
    />
  );
}
